import React from "react";
import { passportClsPrefix } from "../../../../../constants";
import { getLabel, middleware } from "@weapp/utils";
import "./style/index.less";

const clsPrefix = `${passportClsPrefix}-password-strength`

interface PasswordStrengthProps {
  value: string
}
@middleware('weappPassportWeb', 'PasswordStrength')
export class PasswordStrength extends React.Component<PasswordStrengthProps> {
  state = {
    value: ""
  }

  componentDidMount(): void {
    this.setState({ value: this.props.value })
  }

  componentWillReceiveProps(nextProps: Readonly<PasswordStrengthProps>, nextContext: any): void {
    this.setState({ value: nextProps.value });
  }

  render(): React.ReactNode {
    const { value } = this.state;
    const passwordStrength = [{
      name: getLabel('93497', '弱'),
      color: "#f98383",
      regex: /^([a-z]{6,}|[\d]{6,}|[^\da-z]{6,})$/gi
    }, {
      name: getLabel('93496', '中'),
      color: "#ff9200",
      regex: new RegExp("^(((?=.*[a-zA-Z])(?=.*[+-/*!@#$%^&*()_<>,.\$%\^&\*]))|((?=.*[a-zA-Z])(?=.*[0-9]))|((?=.*[+-/*!@#$%^&*()_<>,.\$%\^&\*])(?=.*[0-9])))(?=.{6,})")
    }, {
      name: getLabel('93495', '强'),
      color: "#52C41A",
      regex: new RegExp("^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[+-/*!@#$%^&*()_<>,.\$%\^&\*])(?=.{6,})")
    }]
    const currentStrength = [...passwordStrength].reverse().find((item) => item.regex.test(value)) || passwordStrength[0];
    return (
      <div className={`${clsPrefix}`}>
        <div className={`${clsPrefix}-status`}>
          {passwordStrength.map((item, index) => {
            let level = currentStrength ? passwordStrength.indexOf(currentStrength) + 1 : 0;
            if ((value || "").length < 6) {
              level = 0;
            }
            return <span className={`${clsPrefix}-status-item`}
              key={`status_item${index}`}
              style={{
                width: `calc(${100 / passwordStrength.length}% - 1px)`,
                backgroundColor: level > index ? item.color : "transparent"
              }} />
          })}
        </div>
        <div className={`${clsPrefix}-text`}>{currentStrength?.name}</div>
      </div>
    );
  }
}